import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// utils
import { decomposeExchangeToken } from 'modules/BOD/modules/Search/utils';
// typings
import { SegmentType } from 'modules/Search/constants';
import { LibrarySymbolInfo } from 'modules/TradingChart/components/TradingView/sources/charting_library.min';

// PAY ATTENTION!!!
// Moved from TradingView/utils/services/symbolsSearch/symbolsSearch.ts
// You can find this file in GIT history

dayjs.extend(customParseFormat);

abstract class AbstractSymbolsSearchService {
  abstract resolveSymbolByToken(
    tokenToSearch: string,
    onResult: (result: LibrarySymbolInfo) => void,
    onError: (reason: string) => void,
  ): Promise<void>;

  // Do not need for mobile. Todo: remove in future
  abstract searchSymbolsByUserInput(...args: any): any;

  getSymbolSessionBySegment(exchangeToken: string) {
    const { segment } = decomposeExchangeToken(exchangeToken);

    switch (segment) {
      // NOTE: EQUITY
      case SegmentType.NSE_EQ:
      case SegmentType.BSE_EQ:
      case SegmentType.BSE_INDEX:
      case SegmentType.NSE_INDEX:
        return '1;0915-1530';

      // NOTE: FUTURES AND OPTIONS
      case SegmentType.NSE_FO:
      case SegmentType.BSE_FO:
        return '1;0915-1530';

      // NOTE: CURRENCY
      case SegmentType.NCD_FO:
      case SegmentType.BCD_FO:
        return '1;0900-1700';

      // NOTE: COMMODITIES
      case SegmentType.MCX_FO:
      case SegmentType.MCX_INDEX:
      case SegmentType.NSE_COM:
        return '1;0900-2355';

      default:
        return '24x7';
    }
  }
}

export default AbstractSymbolsSearchService;
